import {Component} from 'react';
import PropTypes from 'prop-types';
import {CSSTransition} from 'react-transition-group';
import {Swipeable} from 'react-swipeable';
import {PageTypes} from 'utils/page';
import Flyout from 'ui/Flyout';
import {withTranslation} from 'react-i18next';
import Acknowledge from './pages/Acknowledge';
import ImageAndText from './pages/ImageAndText';
import Question from './pages/Question';
import Tip from './pages/Tip';
import Definitions from './Definitions';

const COMPONENTS = {
    [PageTypes.ACKNOWLEDGE]: Acknowledge,
    [PageTypes.ICON_PAGE]: ImageAndText,
    [PageTypes.IMAGE_PAGE]: ImageAndText,
    [PageTypes.QUESTION_PAGE]: Question,
    [PageTypes.TIP_PAGE]: Tip,
};

class PageContainer extends Component {
    static propTypes = {
        pages: PropTypes.arrayOf(PropTypes.object).isRequired,
        currentPage: PropTypes.object.isRequired,
        previousAnswers: PropTypes.object,
        direction: PropTypes.oneOf(['left', 'right']),
        isSelectedAnswerCorrect: PropTypes.bool,
        isNextDisabled: PropTypes.bool,
        onSetNextDisabled: PropTypes.func.isRequired,
        onSwipedLeft: PropTypes.func.isRequired,
        onSwipedRight: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };
    state = {
        definitions: null,
        currentPageFormRef: null,
    };

    _onDefinitionsShow = () => {
        this.setState({
            definitions: this.props.currentPage.getTermsList(),
        });
    };

    _onDefinitionsHidden = () => {
        this.setState({
            definitions: null,
        });
    };

    _onQuestionPageShown = questionPageFormReference => {
        this.setState({
            currentPageFormRef: questionPageFormReference,
        });
    };

    get formRef() {
        return this.state.currentPageFormRef;
    }

    render() {
        const {
            t,
            pages,
            currentPage,
            previousAnswers,
            direction,
            isSelectedAnswerCorrect,
            isNextDisabled,
            onSetNextDisabled,
            onSwipedLeft,
            onSwipedRight,
        } = this.props;
        const {definitions} = this.state;

        return (
            <>
                <Swipeable
                    className="PageContainer"
                    onSwipedLeft={onSwipedLeft}
                    onSwipedRight={onSwipedRight}
                    trackMouse
                >
                    {pages.map(page => {
                        const pageId = page.getPageId();
                        const pageType = page.getPageType();
                        const PageComponent = COMPONENTS[pageType];
                        const isShowing = currentPage.getPageId() === pageId;

                        return (
                            <CSSTransition
                                key={pageId}
                                classNames={`Page-${direction}`}
                                in={isShowing}
                                timeout={300}
                                unmountOnExit
                            >
                                <PageComponent
                                    data={page}
                                    previousAnswers={previousAnswers}
                                    isNextDisabled={isNextDisabled}
                                    onSetNextDisabled={onSetNextDisabled}
                                    onShowDefinitions={this._onDefinitionsShow}
                                    onQuestionPageShown={
                                        this._onQuestionPageShown
                                    }
                                    isSelectedAnswerCorrect={
                                        isSelectedAnswerCorrect
                                    }
                                />
                            </CSSTransition>
                        );
                    })}
                </Swipeable>
                {definitions && (
                    <Flyout
                        title={t('definitions')}
                        onHidden={this._onDefinitionsHidden}
                    >
                        <Definitions items={definitions} />
                    </Flyout>
                )}
            </>
        );
    }
}

// withRef enables forwardRef for functional components
// https://react.i18next.com/latest/withtranslation-hoc#use-ref-greater-than-v-10-6-0
export default withTranslation('remonj', {withRef: true})(PageContainer);
